const clock = [
  "M8 14.87a6.88 6.88 0 1 1 .02-13.76A6.88 6.88 0 0 1 8 14.87zM8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zm0 8.1H4.25v.63h4.38V3H8v5.76",
  "M8 0a8 8 0 1 0 .02 16.02A8 8 0 0 0 8 0zm.02 1.6a6.37 6.37 0 1 1 0 12.76 6.37 6.37 0 0 1 0-12.75zM8 2.5l-.5.5v5.1H4.25l-.5.5v.63l.5.5h4.38l.5-.5V3l-.5-.5z"
];
export {
  clock
};
//# sourceMappingURL=clock.js.map
